<template>
  <v-row
    style="margin: 0; width: 100%;"
  >
    <v-col
      :cols="$vuetify.breakpoint.mobile ? 12 : undefined"
      style="display: flex; flex-direction: column;"
    >
      <autocomplete-field
        v-model="formDataCopy.additional_terms"
        :field="{
          key: 'additional_terms',
          label: $t('road-maintenance/aggregator.additional_conditions'),
          editable: true,
          unlock: true,
          style: {
            marginBottom: '2%'
          }
        }"
        :options="{
          custom_display_value: (item) => {
            return item && item.description ? $t(item.description) : ''
          }
        }"
        :items="autocompletesItems"

        :validation-errors="validationErrors"
        @clear-validation-errors="$emit('clear-validation-errors', 'additional_terms')"
      />

      <autocomplete-field
        v-model="formDataCopy.payment_type"
        :field="{
          key: 'payment_type',
          label: $t('road-maintenance/aggregator.payment_type'),
          editable: true,
          unlock: true
        }"
        :options="{
          custom_display_value: (item) => {
            return item && item.description ? $t(item.description) : ''
          }
        }"
        :items="autocompletesItems"
        :validation-errors="validationErrors"
        @clear-validation-errors="$emit('clear-validation-errors', 'payment_type')"
      />
    </v-col>

    <v-col
      :cols="$vuetify.breakpoint.mobile ? 12 : undefined"
    >
      <textarea-field
        v-model="formDataCopy.additional_terms_note"
        :config="{
          key: 'additional_terms_note',
          label: $t('road-maintenance/aggregator.additional_conditions')
        }"
        :validation-errors="validationErrors"
        @clear-validation-errors="$emit('clear-validation-errors', 'additional_terms_note')"
      />
    </v-col>
  </v-row>
</template>

<script>
import { isObject } from 'lodash'
import TextareaField from '@/global/components/view-layouts/tabs-layout/components/fields/TextareaField.vue'
import AutocompleteField from '@/global/components/view-layouts/tabs-layout/components/fields/AutocompleteField.vue'
import { api } from '@/global/services/api'

export default {
  name: 'ConditionFieldsRow',

  components: {
    AutocompleteField,
    TextareaField
  },

  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      formDataCopy: {},
      autocompletesItems: {}
    }
  },

  watch: {
    formData: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val && isObject(val)) {
          this.formDataCopy = val
        }
      }
    }
  },

  async created () {
    try {
      const { data } = await api('road-maintenance').get('traffic-regulation/codebook', {
        types: [
          'ADDITIONAL_TERMS',
          'PAYMENT_TYPE'
        ]
      })
      this.autocompletesItems = {
        additional_terms: {
          data: data?.additional_terms || []
        },
        payment_type: {
          data: data?.payment_type || []
        }
      }
    }
    catch (exception) {
      console.error(exception)
    }
  }
}
</script>

<style scoped>
</style>
